import { createAction } from '@reduxjs/toolkit';
import { THistoryParams } from './types';

export const fetchHistoryData = createAction<THistoryParams>(
  'history/fetchHistoryData',
);
